import React from 'react';
import './Section.scss';

const Section = ({ title, centered, children, theme, slim}) => (
    <div className={`section ${centered ? 'centered' : ''} ${slim ? 'slim' : ''}`}>
        <h2>{title}</h2>
        <div className={`content ${theme}`}>
            {children}
        </div>
    </div>
)

export default Section;


// WEBPACK FOOTER //
// ./src/components/ui/Section/Section.js